import { MenuItem, ShareLinkIcon } from "@flat-ui";
import { ProjectShareDialog } from "@pages/projects/project-share-dialog";
import { BaseProjectProps } from "@custom-types/project-types";
import { useState } from "react";
import { useTrackEvent } from "@utils/track-event/use-track-event";
import { ProjectEvents } from "@utils/track-event/track-event-list";

/** Renders the share project option menu item */
export function ShareProjectOption({ project }: BaseProjectProps): JSX.Element {
  const { trackEvent } = useTrackEvent();
  const [isDialogOpen, setIsDialogOpen] = useState<boolean>(false);

  function onClick(): void {
    setIsDialogOpen(true);

    trackEvent({
      name: ProjectEvents.openShareProject,
      props: {
        projectId: project.id,
        location: "projects-action",
      },
    });
  }

  return (
    <ProjectShareDialog
      project={project}
      isOpen={isDialogOpen}
      onClose={() => setIsDialogOpen(false)}
    >
      <MenuItem label="Share" Icon={ShareLinkIcon} onClick={onClick} />
    </ProjectShareDialog>
  );
}
